import styled from 'styled-components'

const StyledInput = styled.input`
  pointer-events: all;
`

export { StyledInput }
